import React from 'react';
import { connect } from 'react-redux';
import { setAdminNav } from '../../actions';

const AdminMenu = props => {
  const { adminNav, setAdminNav } = props;

  return (
    <div style={styles.container}>
      <button className="track-changes" style={{ ...styles.button, ...(adminNav === 'customers' && styles.selectedButton) }} onClick={() => setAdminNav('customers')}>Customers</button>
      <button className="track-changes" style={{ ...styles.button, ...(adminNav === 'sites' && styles.selectedButton) }} onClick={() => setAdminNav('sites')}>Sites</button>
      <button className="track-changes" style={{ ...styles.button, ...(adminNav === 'devices' && styles.selectedButton) }} onClick={() => setAdminNav('devices')}>Devices</button>
      <button className="track-changes" style={{ ...styles.button, ...(adminNav === 'cameras' && styles.selectedButton) }} onClick={() => setAdminNav('cameras')}>Cameras</button>
      <button className="track-changes" style={{ ...styles.button, ...(adminNav === 'views' && styles.selectedButton) }} onClick={() => setAdminNav('views')}>Views</button>
      <button className="track-changes" style={{ ...styles.button, ...(adminNav === 'users' && styles.selectedButton) }} onClick={() => setAdminNav('users')}>Users</button>
    </div>
  )
}

const mapStateToProps = state => {
  const { adminNav } = state.config;
  return { adminNav }
};

export default connect(mapStateToProps, { setAdminNav })(AdminMenu);

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '1vmin',
    width: '100%',
  },
  button: {
    cursor: 'pointer',
    padding: '3px 10px',
    width: '100%',
    overflow: 'hidden',
    borderRadius: '5px',
    fontSize: '1.5vmin',
  },
  selectedButton: {
    backgroundColor: 'rgb(56, 172, 236)',
  },
}